import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import NotificationHistoryServices from "./NotificationHistory.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getNotificationHistory = (filters) => async (dispatch) => {
  try {
    
    dispatch({
      type: actions.LOADING_NOTIFICATION_HISTORY,
      payload: true,
    });
    const resp = await NotificationHistoryServices.getNotificationHistory(filters);
    dispatch({
      type: actions.GET_NOTIFICATION_HISTORY,
      payload: {
        notificationHistories: resp.data.data,
        notificationHistoriesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.NOTIFICATION_HISTORY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.NOTIFICATION_HISTORY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_NOTIFICATION_HISTORY,
      payload: false,
    });
  }
};


export const saveNotificationHistory =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_NOTIFICATION_HISTORY,
        payload: true,
      });
      const resp = await NotificationHistoryServices.saveNotificationHistory(data);
      const { notificationHistories, notificationHistoriesLength } = getState().notificationHistory;
      const _notificationHistories = [...notificationHistories, resp.data];
      dispatch({
        type: actions.GET_NOTIFICATION_HISTORY,
        payload: {
          notificationHistories: _notificationHistories,
          notificationHistoriesLength: notificationHistoriesLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_NOTIFICATION_HISTORY,
        payload: false,
      });
    }
  };

export const editNotificationHistory =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_NOTIFICATION_HISTORY,
        payload: true,
      });
      const resp = await NotificationHistoryServices.editNotificationHistory(id, data);
      const { notificationHistories, notificationHistoriesLength } = getState().notificationHistory;
      let _notificationHistories = [...notificationHistories]
      _notificationHistories[index] = resp.data;
      dispatch({
        type: actions.GET_NOTIFICATION_HISTORY,
        payload: {
          notificationHistories: _notificationHistories,
          notificationHistoriesLength: notificationHistoriesLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_NOTIFICATION_HISTORY,
        payload: false,
      });
    }
  };

